import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "specificTypeDropdown" }
const _hoisted_2 = { class: "text-lg leading-7 font-medium text-black" }
const _hoisted_3 = { class: "flex flex-col cursor-pointer" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "pt-2 flex flex-col gap-y-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500" }, " Send a custom text message to all enrolled contacts phone numbers. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "New text message", -1)
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_9 = { class: "text-gray-800" }
const _hoisted_10 = { class: "text-sm leading-5 font-normal text-gray-600" }
const _hoisted_11 = {
  key: 1,
  class: "pt-2 flex flex-col gap-y-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500" }, " Randomly send a text message from the selected list/s to all enrolled contacts phone numbers ", -1)
const _hoisted_13 = { class: "w-full flex items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium mr-2" }, "From:", -1)
const _hoisted_15 = { class: "flex gap-x-4 items-center" }
const _hoisted_16 = { class: "flex items-center gap-x-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Randomise", -1)
const _hoisted_18 = { id: "searchOverlayTarget" }
const _hoisted_19 = { class: "flex flex-col max-h-64 overflow-auto w-full top-36" }
const _hoisted_20 = { class: "relative" }
const _hoisted_21 = {
  key: 0,
  class: "py-6 border-0 px-4"
}
const _hoisted_22 = { class: "ml-3 flex flex-col gap-x-2 gap-y-1" }
const _hoisted_23 = { class: "rounded-full items-center flex" }
const _hoisted_24 = { class: "flex justify-start" }
const _hoisted_25 = { class: "text-gray-400 text-xs leading-5 font-normal" }
const _hoisted_26 = {
  key: 0,
  class: "flex justify-between items-center px-3 bg-white h-[54px] w-full rounded-b-md border-t border-gray-200"
}
const _hoisted_27 = { class: "flex items-center gap-x-4" }
const _hoisted_28 = { class: "text-base leading-6 font-medium w-fit" }
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "rounded-full items-center flex" }
const _hoisted_32 = { class: "flex justify-start" }
const _hoisted_33 = { class: "text-gray-400 text-xs leading-5 font-normal" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "New Message", -1)

import { computed, onMounted, ref, watch } from "vue"
import ArrowDown from "@/components/icons/ArrowDown.vue"
import {
    CheckIcon,
    InformationCircleIcon,
    MinusSmIcon,
    PlusSmIcon,
    SearchIcon,
    TrashIcon,
} from "@heroicons/vue/outline"
import GgmsModal from "@/components/GgmsModal.vue"
import CreatingMessage from "@/components/profile-details/middle-panel/CreatingMessage.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import { Template } from "@/shared/models/template"
import { Message } from "@/shared/models/message"
import { useWorkflowStore } from "@/stores/workflow"
import { useTemplateStore } from "@/stores/template"
import { debounce, formatHumanReadableDate, getCookieValue, getUser, stripHtml } from "@/shared/utils/helpers"
import GgmsChip from "@/components/GgmsChip.vue"
import { useTagStore } from "@/stores/tag"
import ContactDropdown from "@/components/profile-details/middle-panel/ContactDropdown.vue"
import { Sender } from "@/shared/models/sender"
import { useAgencyStore } from "@/stores/agency"
import { SendTextMessageNodeType } from "@/shared/models/workflow"
import GgmsTemplateModal from "@/components/GgmsTemplateModal.vue"
import { AgencyDomain } from "@/shared/models/agency"
import { Tag } from "@/shared/models/tag"
import { GgmsError } from "@/shared/services/client"


export default /*#__PURE__*/_defineComponent({
  __name: 'SendTextMessageComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()
const templateStore = useTemplateStore()
const tagStore = useTagStore()
const agencyStore = useAgencyStore()

const isTypeModalOpen = ref(false)
const typeMenu = ref()
const isCreatingMessageModalOpen = ref(false)
const searchTerm = ref("")
const data = ref<Template[]>([])
const isSearching = ref(false)
const isAllSelected = ref(false)
const total = ref(0)
const showData = ref(false)
const searchMenu = ref()
const senders = ref<Sender[]>([])
const user = getUser()

const isPreviewOpen = ref(false)
const isOpenCreateTemplateModal = ref(false)
const newTemplate = ref({} as Template)
const isOpenDeleteTemplateModal = ref(false)
const deleteableTemplate = ref({} as Template)
const isViewingFormatted = ref(true)
const isTextBodyModified = ref(false)
const selectedDomains = ref<AgencyDomain[]>([])
const domains = computed(() => agencyStore.agency.agencyDomains || [])
const isDomainsDisabled = ref(false)
const selectedTags = ref<Tag[]>([])
const tags = computed(() => tagStore.tableState.data || [])
const specialVariable = ref("")
const currentMessage = ref()

const agency = ref(agencyStore.agency)

const cachedTags = computed(() => tagStore.cachedTags)
const selectAllText = computed(() => (isAllSelected.value ? "Deselect all" : `Select all (${total.value})`))

const selectionTypes = [
    { label: "Custom text message", value: SendTextMessageNodeType.custom },
    { label: "Pre-made text message", value: SendTextMessageNodeType.preMade },
    { label: "Texts containing certain tags", value: SendTextMessageNodeType.containsTags },
    { label: "From list of saved texts", value: SendTextMessageNodeType.listOfSavedTexts },
]

const selectionTitle = computed(() => {
    if (workflowStore.modelValue.value === SendTextMessageNodeType.custom) {
        return "Custom text message"
    }
    if (workflowStore.modelValue.value === SendTextMessageNodeType.preMade) {
        return "Pre-made text message"
    }
    if (workflowStore.modelValue.value === SendTextMessageNodeType.containsTags) {
        return "Texts containing certain tags"
    }
    return "From list of saved texts"
})

function toggleTypeMenu(event?: Event) {
    if (isTypeModalOpen.value) {
        typeMenu.value.hide()
        isTypeModalOpen.value = false
    } else {
        typeMenu.value.show(event)
        isTypeModalOpen.value = true
    }
}

async function selectType(type: string) {
    typeMenu.value.hide()
    isTypeModalOpen.value = false
    workflowStore.modelValue.value = type
    clearSelectedData()
    await getTemplates()
    total.value = data.value.length
}

function openCreateMessageModal() {
    isCreatingMessageModalOpen.value = true
}

function closeCreateMessageModal() {
    isCreatingMessageModalOpen.value = false
}

function saveTextMessage() {
    isCreatingMessageModalOpen.value = false
}

function deleteTextMessage() {
    workflowStore.messagePayload = {} as Message
}

async function getTemplates() {
    templateStore.tableState.templateType = "sms"
    templateStore.tableState.search = searchTerm.value
    await templateStore.getTemplates()
    data.value = templateStore.tableState.data
}

function isTemplateChecked(template: Template) {
    return !!templateStore.selectedData.find((el) => el._id === template._id)
}

function clearSelectedData() {
    templateStore.selectedData = []
}

function deleteTemplate(template: Template) {
    templateStore.selectedData.splice(templateStore.selectedData.indexOf(template), 1)
}

function onSelect() {
    if (isAllSelected.value) {
        clearSelectedData()
    } else {
        templateStore.selectedData = data.value
    }
    isAllSelected.value = !isAllSelected.value
}

function onClick(template: Template) {
    if (isTemplateChecked(template)) {
        const index = templateStore.selectedData.findIndex((el) => el._id === template._id)
        templateStore.selectedData.splice(index, 1)
        return
    }

    templateStore.selectedData.push(template)
}

function closeSearchMenu() {
    showData.value = true
    searchMenu.value.hide()
    workflowStore.areButtonDisabled = false
}

function toggleSearchMenu(event?: Event) {
    searchMenu.value.show(event)
}

function setOutboundPhoneNumbers() {
    if (user?.outboundPhoneNumber) {
        senders.value.push({
            name: user?.fullName || "",
            phone: user?.outboundPhoneNumber,
        })
    }

    const agencyPhone = agencyStore.agency?.agencyOutboundPhoneNumber
    if (agencyPhone) {
        senders.value.push({
            name: agencyStore.agency?.agencyName || "",
            phone: agencyPhone,
        })
    }

    if (senders.value.length) {
        workflowStore.selectedSender = senders.value?.[0]
        return
    }
}

function closePreview() {
    isPreviewOpen.value = false
}

function openPreview() {
    isPreviewOpen.value = true
}

function closeCreateTemplateModal() {
    templateStore.validationError = {} as GgmsError
    newTemplate.value = {} as Template
    isOpenCreateTemplateModal.value = false
    closePreview()
    isTextBodyModified.value = false
    selectedDomains.value = []
    selectedTags.value = []
    specialVariable.value = ""
}

function openCreateTemplateModal(template: Template) {
    newTemplate.value = Object.assign({}, template)
    newTemplate.value.textBody = stripHtml(newTemplate.value.body)
    isTextBodyModified.value = true
    // add domains and tags to selected
    selectedDomains.value = domains.value.filter((domain) => newTemplate.value?.domainId === domain._id)
    isDomainsDisabled.value = true
    const templateTagIds = newTemplate.value?.tags?.map((tag) => tag._id)
    selectedTags.value = tags.value.filter((tag) => templateTagIds?.includes(tag._id))
    specialVariable.value = template?.displayName || ""
    isViewingFormatted.value = true
    isOpenCreateTemplateModal.value = true
}

function openDeleteTemplateModal(template: Template) {
    if (isOpenCreateTemplateModal.value) {
        closeCreateTemplateModal()
    }
    isOpenDeleteTemplateModal.value = true
    deleteableTemplate.value = template
}

function updateSelectedTemplate(template: Template) {
    const index = templateStore.selectedData.findIndex((el) => el._id === template._id)
    templateStore.selectedData.splice(index, 1)
    const updatedTemplate = templateStore.tableState.data.find((newTemplate) => template._id === newTemplate._id)
    templateStore.selectedData.push(updatedTemplate)
}

function openUpdateModal() {
    currentMessage.value = workflowStore.messagePayload
    openCreateMessageModal()
}

watch(
    () => workflowStore.messagePayload,
    () => {
        workflowStore.areButtonDisabled = !(workflowStore.messagePayload?.from && workflowStore.messagePayload?.body)
    }
)

watch(
    () => [templateStore.selectedData.length, workflowStore.modelValue.event],
    () => {
        if (!templateStore.selectedData.length) {
            workflowStore.areButtonDisabled = true
            return
        }
        workflowStore.areButtonDisabled = false
    }
)

watch(
    () => searchTerm.value,
    debounce(async () => {
        isSearching.value = true
        await getTemplates()
        isSearching.value = false
    }, 250)
)

onMounted(async () => {
    if (templateStore.selectedData.length) {
        showData.value = true
    }
    setOutboundPhoneNumbers()
    await getTemplates()
    tagStore.tableState.typeName = "messaging-template"
    await tagStore.getTags()
    total.value = data.value.length
})

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "flex gap-x-2 cursor-pointer w-fit",
          onClick: toggleTypeMenu
        }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(selectionTitle.value), 1),
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(ArrowDown, { class: "rotate-180 fill-gray-700" }, null, 512), [
              [_vShow, isTypeModalOpen.value]
            ]),
            _withDirectives(_createVNode(ArrowDown, { class: "fill-gray-700" }, null, 512), [
              [_vShow, !isTypeModalOpen.value]
            ])
          ])
        ]),
        _createVNode(_component_OverlayPanel, {
          ref_key: "typeMenu",
          ref: typeMenu,
          appendTo: "#specificTypeDropdown",
          class: "bg-white rounded-md !left-0 ring-1 ring-black ring-opacity-5 shadow-lg mx-6 right-1 w-64 top-0"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(selectionTypes, (type) => {
                return _createElementVNode("div", {
                  key: type.value,
                  class: "flex justify-between text-sm leading-5 font-normal p-3 items-center border-b",
                  onClick: ($event: any) => (selectType(type.value))
                }, [
                  _createElementVNode("div", null, _toDisplayString(type.label), 1),
                  (_unref(workflowStore).modelValue.value === type.value)
                    ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                        key: 0,
                        class: "w-4 h-4"
                      }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_4)
              }), 64))
            ])
          ]),
          _: 1
        }, 512)
      ]),
      (_unref(workflowStore).modelValue.value === _unref(SendTextMessageNodeType).custom)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            (!_unref(workflowStore).messagePayload?.from)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "flex items-center text-sm leading-5 font-medium text-gray-900 gap-x-1 cursor-pointer",
                  onClick: openCreateMessageModal
                }, [
                  _createVNode(_unref(PlusSmIcon), { class: "h-5 w-5" }),
                  _hoisted_7
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "py-2 pl-2 flex flex-col gap-y-2 max-w-[350px] cursor-pointer w-full",
                    onClick: openUpdateModal
                  }, [
                    _createElementVNode("span", _hoisted_9, "From: " + _toDisplayString(_unref(workflowStore).messagePayload?.from?.name) + " " + _toDisplayString(_unref(workflowStore).messagePayload?.from?.number), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(workflowStore).messagePayload?.body), 1)
                  ]),
                  _createVNode(_unref(TrashIcon), {
                    class: "w-5 h-5 cursor-pointer text-gray-900",
                    onClick: deleteTextMessage
                  })
                ]))
          ]))
        : _createCommentVNode("", true),
      (_unref(workflowStore).modelValue.value === _unref(SendTextMessageNodeType).preMade)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(ContactDropdown, {
                selectedSender: _unref(workflowStore).selectedSender,
                "onUpdate:selectedSender": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).selectedSender) = $event)),
                senders: senders.value,
                type: "sms"
              }, null, 8, ["selectedSender", "senders"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_unref(InformationCircleIcon), { class: "w-5 h-5" })
              ]),
              _createVNode(_component_InputSwitch, {
                modelValue: _unref(workflowStore).modelValue.event,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(GgmsInput, {
                "input-class": "bg-gray-100 border-0",
                modelValue: searchTerm.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchTerm).value = $event)),
                small: true,
                iconEnd: _unref(SearchIcon),
                placeholder: "Search",
                onInput: toggleSearchMenu,
                onClick: toggleSearchMenu
              }, null, 8, ["modelValue", "iconEnd"]),
              _createVNode(_component_OverlayPanel, {
                ref_key: "searchMenu",
                ref: searchMenu,
                class: "!left-0 ring-1 ring-black ring-opacity-5 shadow-lg rounded-md bg-white mx-6 right-1",
                appendTo: "#searchOverlayTarget"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (!data.value?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, "No results found"))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.value, (template) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: template._id,
                              class: "flex gap-x-2 px-4 top-0 py-3 border-b border-gray-200 last:border-0",
                              tabindex: "0"
                            }, [
                              _createVNode(GgmsCheckBox, {
                                checked: isTemplateChecked(template),
                                classes: ['mt-1'],
                                centered: false,
                                onClick: ($event: any) => (onClick(template))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(template.displayName), 1),
                                    _createElementVNode("div", _hoisted_24, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.tags, (tag) => {
                                        return (_openBlock(), _createBlock(GgmsChip, {
                                          key: tag._id,
                                          bgColor: cachedTags.value[tag._id]?.backgroundColor,
                                          textColor: cachedTags.value[tag._id]?.foregroundColor,
                                          isRemovable: false,
                                          class: "h-6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(tag.displayName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["bgColor", "textColor"]))
                                      }), 128))
                                    ]),
                                    _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(formatHumanReadableDate)(new Date(template.updatedAt), true)), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["checked", "onClick"])
                            ]))
                          }), 128)),
                      (isSearching.value)
                        ? (_openBlock(), _createBlock(GgmsLoading, { key: 2 }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_unref(templateStore).selectedData.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", {
                            class: "bg-gray-300 w-4 h-4 rounded-sm cursor-pointer",
                            onClick: clearSelectedData
                          }, [
                            _createVNode(_unref(MinusSmIcon), { class: "w-4 h-4" })
                          ]),
                          _createElementVNode("p", _hoisted_28, [
                            _createTextVNode(_toDisplayString(_unref(templateStore).selectedData.length) + " selected - ", 1),
                            _createElementVNode("span", {
                              class: "font-medium text-primary-color-600 hover:text-primary-color-500 cursor-pointer",
                              onClick: onSelect
                            }, _toDisplayString(selectAllText.value), 1)
                          ])
                        ]),
                        _createVNode(GgmsButton, { onClick: closeSearchMenu }, {
                          default: _withCtx(() => [
                            _createTextVNode("Done")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512)
            ]),
            (showData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateStore).selectedData, (template) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: template._id,
                      class: "flex justify-between items-center border-b border-gray-200 last:border-0 py-2.5 px-2"
                    }, [
                      _createElementVNode("div", {
                        class: "ml-3 flex flex-col gap-x-2 gap-y-1 cursor-pointer w-full",
                        onClick: _withModifiers(($event: any) => (openCreateTemplateModal(template)), ["prevent","stop"])
                      }, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(template.displayName), 1),
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.tags, (tag) => {
                            return (_openBlock(), _createBlock(GgmsChip, {
                              key: tag._id,
                              bgColor: cachedTags.value[tag._id]?.backgroundColor,
                              textColor: cachedTags.value[tag._id]?.foregroundColor,
                              isRemovable: false,
                              class: "h-6"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(tag.displayName), 1)
                              ]),
                              _: 2
                            }, 1032, ["bgColor", "textColor"]))
                          }), 128))
                        ]),
                        _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(formatHumanReadableDate)(new Date(template.updatedAt), true)), 1)
                      ], 8, _hoisted_30),
                      _createVNode(_unref(TrashIcon), {
                        class: "x-5 h-5 m-1 cursor-pointer",
                        onClick: ($event: any) => (deleteTemplate(template))
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(GgmsModal, {
      open: isCreatingMessageModalOpen.value,
      bodyClass: "p-0",
      headerClass: "border-b border-gray-200 py-5",
      size: "3xl",
      onCloseModal: closeCreateMessageModal
    }, {
      header: _withCtx(() => [
        _hoisted_34
      ]),
      default: _withCtx(() => [
        _createVNode(CreatingMessage, {
          isWorkflow: true,
          textMessage: currentMessage.value,
          onSaveTextMessage: saveTextMessage
        }, null, 8, ["textMessage"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(GgmsTemplateModal, {
      open: isOpenCreateTemplateModal.value,
      isCreateTemplate: false,
      isPreviewOpen: isPreviewOpen.value,
      newTemplate: newTemplate.value,
      isDomainsDisabled: true,
      domains: domains.value,
      selectedDomains: selectedDomains.value,
      tags: tags.value,
      selectedTags: selectedTags.value,
      showDeleteButton: false,
      typeDropdownDisabled: true,
      "onUpdate:selectedTags": _cache[3] || (_cache[3] = (value) => (selectedTags.value = value)),
      "onUpdate:selectedDomains": _cache[4] || (_cache[4] = (value) => (selectedDomains.value = value)),
      onClosePreview: closePreview,
      onOpenPreview: openPreview,
      onCloseModal: closeCreateTemplateModal,
      onOpenDelete: _cache[5] || (_cache[5] = ($event: any) => (openDeleteTemplateModal(newTemplate.value))),
      onSaveTemplate: _cache[6] || (_cache[6] = ($event: any) => (updateSelectedTemplate(newTemplate.value)))
    }, null, 8, ["open", "isPreviewOpen", "newTemplate", "domains", "selectedDomains", "tags", "selectedTags"])
  ], 64))
}
}

})